import React, { useState } from 'react';
import BedTypeList from './BedTypeList';
import { ROOM_FEATURES, BED_TYPES } from '../../constants/roomConfig';
import '../css/AddRoom.css';

const EMPTY_CONFIG = {
  name: '',
  beds: [{ type: BED_TYPES[0].type, region: BED_TYPES[0].region, count: 1 }],
  features: [],
  price_per_night: '',
};

export default function ConfigurationForm({ initial, onSave, onCancel }) {
  const [form, setForm] = useState(initial || EMPTY_CONFIG);
  const [error, setError] = useState('');
  const [showOthers, setShowOthers] = useState(
    () => !!(initial?.features?.some((f) => !ROOM_FEATURES.includes(f)))
  );
  const [otherInput, setOtherInput] = useState('');

  const customFeatures = form.features.filter((f) => !ROOM_FEATURES.includes(f));

  const toggleFeature = (feature, checked) => {
    const next = checked
      ? [...form.features, feature]
      : form.features.filter((f) => f !== feature);
    setForm({ ...form, features: next });
  };

  const addCustomFeature = () => {
    const val = otherInput.trim();
    if (!val || form.features.includes(val)) return;
    setForm({ ...form, features: [...form.features, val] });
    setOtherInput('');
  };

  const removeCustomFeature = (val) => {
    setForm({ ...form, features: form.features.filter((f) => f !== val) });
  };

  const handleOtherKeyDown = (e) => {
    if (e.key === 'Enter') { e.preventDefault(); addCustomFeature(); }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim()) {
      setError('Configuration name is required');
      return;
    }
    if (!form.price_per_night || parseFloat(form.price_per_night) <= 0) {
      setError('Price per night must be greater than 0');
      return;
    }
    setError('');
    onSave({
      ...form,
      name: form.name.trim(),
      price_per_night: parseFloat(form.price_per_night),
    });
  };

  return (
    <form onSubmit={handleSubmit} className="config-form">
      {error && <div className="alert alert-danger py-2">{error}</div>}

      <div className="row mb-3">
        <div className="col-8">
          <label className="form-label">Configuration Name <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. Twin Setup"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
        </div>
        <div className="col-4">
          <label className="form-label" htmlFor="price-per-night-input">Price / Night <span className="text-danger">*</span></label>
          <input
            id="price-per-night-input"
            type="number"
            className="form-control"
            min={1}
            placeholder="e.g. 150"
            value={form.price_per_night}
            onChange={(e) => setForm({ ...form, price_per_night: e.target.value })}
            style={{ MozAppearance: 'textfield' }}
            onWheel={(e) => e.target.blur()}
          />
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Bed Setup</label>
        <BedTypeList
          beds={form.beds}
          onChange={(beds) => setForm({ ...form, beds })}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Features</label>
        <div className="d-flex flex-wrap gap-2 mb-2">
          {ROOM_FEATURES.map((feature) => (
            <div key={feature} className="form-check form-check-inline">
              <input
                type="checkbox"
                id={`feature-${feature}`}
                className="form-check-input"
                checked={form.features.includes(feature)}
                onChange={(e) => toggleFeature(feature, e.target.checked)}
              />
              <label className="form-check-label" htmlFor={`feature-${feature}`}>
                {feature}
              </label>
            </div>
          ))}
          <div className="form-check form-check-inline">
            <input
              type="checkbox"
              id="feature-other"
              className="form-check-input"
              checked={showOthers}
              onChange={(e) => setShowOthers(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="feature-other">Other</label>
          </div>
        </div>

        {showOthers && (
          <div className="mt-2">
            <div className="d-flex gap-2 mb-2">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Type a feature and press Enter or Add"
                value={otherInput}
                onChange={(e) => setOtherInput(e.target.value)}
                onKeyDown={handleOtherKeyDown}
              />
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={addCustomFeature}
              >
                Add
              </button>
            </div>
            {customFeatures.length > 0 && (
              <div className="d-flex flex-wrap gap-1">
                {customFeatures.map((f) => (
                  <span key={f} className="badge bg-secondary d-flex align-items-center gap-1">
                    {f}
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      style={{ fontSize: '0.6rem' }}
                      onClick={() => removeCustomFeature(f)}
                    />
                  </span>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      <div className="d-flex gap-2 justify-content-end">
        <button type="button" className="btn btn-dark" style={{ minWidth: 90 }} onClick={onCancel}>Cancel</button>
        <button type="submit" className="btn" style={{ minWidth: 90, background: '#D9A128', color: '#fff' }}>Save</button>
      </div>
    </form>
  );
}
